import { connect } from "react-redux";

import Analysen from "./Analysen";

export default connect(state => ({
	print: state.settings.print
}))(Analysen);
